import type { UIMessage } from 'ai';

export const getMessageTextContent = (message: UIMessage|null): string => {
    if (!message) return '';

    return message.parts
        .filter(part => part.type === 'text')
        .map(part => part.type === 'text' ? part.text : '')
        .join('');
};
